var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-check", class: { error: _vm.showError } },
    [
      _c("input", {
        staticClass: "form-check-input",
        attrs: {
          type: "checkbox",
          id: "privacy-policy-accept" + _vm._uid,
          "data-testing": "privacy-policy-accept-register"
        },
        domProps: { checked: _vm.value },
        on: {
          change: function($event) {
            return _vm.onValueChanged($event.target.checked)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "form-check-label",
          attrs: { for: "privacy-policy-accept" + _vm._uid }
        },
        [
          _c("span", { domProps: { innerHTML: _vm._s(_vm.labelHtml) } }),
          _c("sup", [_vm._v("*")])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }